var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgRefresh16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.075 1a.5.5 0 0 1 .5.5v2.55l.422-.432.005-.004a5.91 5.91 0 1 1-1.4 6.146.5.5 0 0 1 .944-.332A4.91 4.91 0 1 0 4.71 4.319l-.448.46h2.4a.5.5 0 0 1 0 1H3.073a.5.5 0 0 1-.5-.501L2.575 1.5a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })));
});
SvgRefresh16.displayName = "SvgRefresh16";
export default SvgRefresh16;